import React from "react";
import { useNavigate } from "react-router-dom";
import { ArrowRight } from "lucide-react";

export function TemplatesPreview() {
  const navigate = useNavigate();

  return (
    <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-24">
      <div className="text-center mb-16">
        <h2 className="inline-block text-3xl font-bold mb-4 bg-gradient-to-r from-volt-green via-volt-blue to-volt-green text-transparent bg-clip-text pb-2 border-b-2 border-volt-blue/20">
          Popular Templates
        </h2>
        <p className="text-gray-400 mt-4">
          Start with our most-used block patterns
        </p>
      </div>

      <div className="grid md:grid-cols-2 gap-8">
        <div
          onClick={() => navigate("/templates/pricing")}
          className="group bg-white/5 backdrop-blur-sm rounded-xl p-8 cursor-pointer hover:bg-white/10 transition-all hover:translate-y-[-2px] hover:shadow-lg hover:shadow-volt-blue/5"
        >
          <div className="flex items-center justify-between mb-4">
            <h3 className="text-xl font-semibold text-white">
              Modern Pricing Cards
            </h3>
            <ArrowRight className="h-5 w-5 text-volt-blue transform transition-transform group-hover:translate-x-1" />
          </div>
          <p className="text-gray-400">
            Professional pricing tables with gradients and interactive hover
            states. Perfect for showcasing your products and services.
          </p>
        </div>

        <div
          onClick={() => navigate("/templates/call-to-action")}
          className="group bg-white/5 backdrop-blur-sm rounded-xl p-8 cursor-pointer hover:bg-white/10 transition-all hover:translate-y-[-2px] hover:shadow-lg hover:shadow-volt-blue/5"
        >
          <div className="flex items-center justify-between mb-4">
            <h3 className="text-xl font-semibold text-white">Call to Action</h3>
            <ArrowRight className="h-5 w-5 text-volt-blue transform transition-transform group-hover:translate-x-1" />
          </div>
          <p className="text-gray-400">
            High-converting CTA sections with gradient backgrounds and
            attention-grabbing designs that drive action.
          </p>
        </div>
      </div>

      <div className="text-center mt-12">
        <button
          onClick={() => navigate("/templates")}
          className="group px-6 py-3 text-gray-300 bg-white/5 backdrop-blur-sm rounded-lg font-medium hover:bg-white/10 transition-all hover:translate-y-[-2px]"
        >
          View All Templates
          <ArrowRight className="inline-block ml-2 h-4 w-4 transition-transform group-hover:translate-x-1" />
        </button>
      </div>
    </div>
  );
}
